/*
 * Copyright (C) 2019 - present Marek Kuzora - All Rights Reserved.
 */


import GoogleAnalytics from 'react-ga4';

if (window.location.hostname !== 'localhost')
{
  // TODO token is probably wrong. Need to migrate to v4.
  GoogleAnalytics.initialize('G-148150744-1');

  // Setting IP anonymization.
  GoogleAnalytics.set({ anonymizeIp: true });


  // For now we don't log location.search - no point keeping all the refresh tokens!
  GoogleAnalytics.send({ hitType: 'pageview', page: window.location.pathname + window.location.hash });

  // TODO this stopped working as we no longer have onhashchange event fired!
  window.onhashchange = (event) =>
  {
    GoogleAnalytics.send({ hitType: 'pageview', page: window.location.pathname + window.location.hash + window.location.search });
  }
}
